// extracted by mini-css-extract-plugin
export var dropdown = "_gt-0";
export var imagePlaceholder = "_gt-2";
export var imageWrapper = "_gt-3";
export var productImage = "_gt-1";
export var truncateContainer = "_gt-4";
export var truncateText = "_gt-5";